<div class="form-group mt-2" *ngIf="!disabled">
  <label class="label mb-3" for="file">{{ label | titlecase }}</label>

  <div class="text-center mb-3">
    <i class="uploadIcon bi bi-cloud-upload"></i>
  </div>

  <div>
    <input #uploadField id="file" type="file" [accept]="fileFormat" (change)="onFileChange($event)" />

    <div class="small text-muted text-right">
      Max file size <span class="material-indigo"><b>5mb</b></span>
      <span *ngIf="fileFormat"
        >. Accept only
        <span class="material-indigo"
          ><b>{{ fileFormat }}</b></span
        ></span
      >
    </div>
  </div>
</div>

<div class="thumbnail" *ngIf="image">
  <img [src]="image" alt="Image" class="img-thumbnail">
  <button type="button" class="close" aria-label="Close" (click)="removeImage()" *ngIf="!disabled">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

